import { fbq, gtag } from 'src/helpers/marketing';

export const step1 = {
  isOpenPopup2: false,

  get isValidHp() {
    return (
      ((this.userInput ?? {}).hp ?? '').match(
        /01([0|1|6|7|8|9])\-[0-9]{3,4}-[0-9]{4}/g,
      ) !== null
    );
  },

  get isNextBtnActive() {
    return (
      this.userInput.name !== '' &&
      this.isValidHp &&
      this.userInput.requestType !== ''
    );
  },

  closePopup2() {
    this.isOpenPopup2 = false;
  },

  openPopup2() {
    this.isOpenPopup2 = true;
    gtag('AW-16776503624/_Wn3CM-V0PEZEMjC1L8-');
    fbq('Request_Click1');
    console.log('event 2');
  },
};
